import * as React from 'react';

import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-sm border border-ink/20 bg-transparent px-3 py-2 text-sm text-ink shadow-none transition-colors',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-ink',
          'placeholder:text-ink/40',
          'focus-visible:outline-none focus-visible:border-ink/50 focus-visible:ring-1 focus-visible:ring-ochre/40',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
